import DimensionIdEnum from "./DimensionId";

export default class DimensionSelectValueById {
  static get [DimensionIdEnum.sex]() {
    return {
      male: "F10D28BE-8FE3-ED11-9F73-6045BD9258EA",
      female: ""
    };
  }
  static get [DimensionIdEnum.medicalCardStatus]() {
    return {
      new: "95CD39C5-B0B9-ED11-9174-CC60C8A3AA44",
      discharged: "",
      inWork: "",
    };
  }
  static get [DimensionIdEnum.relation]() {
    return {
      myself: "EFF8D958-E3B8-ED11-9174-CC60C8A3AA44",
      discharged: "",
      inWork: "",
    };
  }
  static get [DimensionIdEnum.humanOrAnimal]() {
    return {
      human: "A3FB7CB7-8FE3-ED11-9F73-6045BD9258EA",
      animal: "",
    };
  }
}
